import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import SubmitProfile from "./pages/SubmitProfile";
import RetrieveProfile from "./pages/RetrieveProfile";
import RequestProfessional from "./pages/RequestProfessional";
import AdminDashboard from "./pages/AdminDashboard";
import AdminSettings from "./pages/AdminSettings";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/submit" element={<SubmitProfile />} />
          <Route path="/retrieve" element={<RetrieveProfile />} />
          <Route path="/request-professional" element={<RequestProfessional />} />
          <Route path="/admin-secure-bd2026" element={<AdminDashboard />} />
          <Route path="/admin-secure-bd2026/settings" element={<AdminSettings />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
